export default __webpack_public_path__ + "static/media/instant.ce493618.svg";